import { fetchRnaCatalog } from "./RnaCatalog";
var RnaCatalogLoader = /** @class */ (function () {
    function RnaCatalogLoader(mode, catalogType, product) {
        this.mode = mode;
        this.catalogType = catalogType;
        this.product = product;
    }
    RnaCatalogLoader.prototype.load = function () {
        return Promise.resolve(fetchRnaCatalog(this.mode, this.catalogType, undefined, this.product));
    };
    return RnaCatalogLoader;
}());
export { RnaCatalogLoader };
//# sourceMappingURL=RnaCatalogLoader.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-cish/RnaCatalogLoader.js
// module id = 179
// module chunks = 0